export default __webpack_public_path__ + "static/210528_夏日角色熱更預告_tc-79ccb21a2fa7f80a627d08ada2bcd1eb.png";